import style from './CAFleet-hashed.scss';
import LocaleUtil from 'gw-portals-util-js/LocaleUtil';

function getSortingStyle(attribute, sortingProperty, numeric, descending) {
    let icon = null;
    let type = 'sortIndicator-icon';

    if (!sortingProperty || sortingProperty !== attribute) {
        // no sorting applied or sorting property is different than considered attribute/column
        // need to provide 'neutral' icon
        icon = 'fa-exchange fa-rotate-90';
        type += '_inactive';
    } else {
        // sorting applies to the considered attribute
        // need to provide proper icon depending on the direction
        icon = `fa-sort-${numeric ? 'amount' : 'alpha'}-${descending ? 'desc' : 'asc'}`;
        type += '_active';
    }
    return `fa ${icon} ${style[type]}`;
}

class CAFleetCtrl {
    constructor($scope, $filter, $translate, claimViewModel, PolicyService, TranslateService, LocaleService, AddressUtil, fleetPageSize) {
        this.updateFilterState = (queriedData, filterApplicable, query) => {
            this.updateVehiclesList(queriedData);
            this.filterApplicable = filterApplicable;
            this.query = query;
        };

        this.sortProperties = (attribute, descending) => {
            if (attribute === 'year') {
                this.allVehicles = this.allVehicles.slice().sort((a, b) => {
                    const aYear = a.year;
                    const bYear = b.year;
                    return descending ? bYear - aYear : aYear - bYear;
                });
                return;
            }
            this.allVehicles =
                LocaleUtil.sortProperties(this.allVehicles, this.LocaleService.getCurrentLocale(), attribute, descending);
        };
        this.getSortingStyle = getSortingStyle;
        this.keepDropdownOpen = (event) => {
            event.stopPropagation();
        };

        this.pageSize = fleetPageSize;
        this.claimVm = claimViewModel();
        this.reset = false;
        this.loading = true;
        this.errorMsg = null;
        this.filterApplicable = null;
        this.query = null;
        this.$filter = $filter;
        this.PolicyService = PolicyService;
        this.TranslateService = TranslateService;
        this.LocaleService = LocaleService;
        this.$scope = $scope;
        this.$translate = $translate;

        this.allVehicles = null;
        this.vehicles = null;
        this.filteredVehicles = null;
        this.selectedVehicles = null;
        this.sharedPageNum = null;

        this.inUpdateState = false;

        this.availableModels = [];
        this.selectedModel = null;
        this.selectedModelIndex = 0;

        if (!this.claimVm.policy.lobs.commercialAuto) {
            this.claimVm.policy.lobs.value = {commercialAuto: {vehicles: []}};
        }

        this.policyVehicles = this.claimVm.policy.lobs.commercialAuto.vehicles.value;
        this.translateMessages();
        this.initVehicles();

        $scope.$watchGroup(
            [() => this.selectedModel, () => this.selectedModelIndex, () => this.allVehicles],
            () => {
                const selected = this.availableModels[this.selectedModelIndex];
                this.filteredAllVehicles = this.selectedModelIndex === 0
                    ? this.allVehicles
                    : this.allVehicles.filter(v => v.make === selected.make && v.model === selected.model);
            }
        );
    }

    translateMessages() {
        this.translation = {
            label: '',
            error: ''
        };

        this.TranslateService.translate({
            object: this.translation,
            displayKey: 'fnol.ca.views.ca-fleet.Vehicles',
            propName: 'label',
            scope: this.$scope
        });

        this.TranslateService.translate({
            object: this.translation,
            displayKey: 'fnol.ca.views.ca-fleet.No results found. Please try widening your search criteria.',
            propName: 'error',
            scope: this.$scope
        });
    }

    initVehicles() {
        this.loading = true;
        this.errorMsg = null;
        this.loader = this.PolicyService.getPolicySummaryRiskUnits(
            this.claimVm.policy.policyNumber.value,
            this.claimVm.lossDate.value
        ).then((riskUnits) => {
            this.loading = false;
            const allVehicles = riskUnits.lobs.commercialAuto.vehicles;
            this.vehicles = riskUnits.lobs.commercialAuto.vehicles;
            allVehicles.forEach(vehicle => {
                vehicle.selected = this.policyVehicles.findIndex(unit => unit.policySystemId === vehicle.policySystemId) > -1;
            });
            this.allVehicles = allVehicles;
            this.updateSelectionSummary();
            this.$translate('fnol.ca.views.ca-fleet.All Models').then(allModels =>
                this.updateAvailableModels(allModels));
        }, (error) => {
            this.errorMsg = this.translation.error + error;
        });
    }

    vehiclesChanged() {
        this.vehicles.forEach(unit => {
            const index = this.policyVehicles.findIndex(policyUnit => policyUnit.policySystemId === unit.policySystemId);
            if (unit.selected && index < 0) {
                this.policyVehicles.push(unit);
            } else if (!unit.selected && index >= 0) {
                this.policyVehicles.splice(index, 1);
            }
        });
    }

    updateAvailableModels(allModels) {
        const models = new Map();
        this.allVehicles.forEach(vehicle => models.set(`${vehicle.make} ${vehicle.model}`, {
            frontendKey: `${vehicle.make} ${vehicle.model}`,
            make: vehicle.make,
            model: vehicle.model
        }));

        const modelsArr =
            LocaleUtil.sortProperties(Array.from(models.values()), this.LocaleService.getCurrentLocale(), 'frontendKey', false);
        this.availableModels = [{
            frontendKey: allModels
        }].concat(modelsArr);
    }

    updateSelectionSummary() {
        this.selectedVehicles = this.allVehicles.filter(ru =>
            this.policyVehicles.findIndex(policyUnit => policyUnit.policySystemId === ru.policySystemId) !== -1);
    }

    updateVehiclesList(vehicles) {
        this.vehicles = vehicles;
        this.reset = !this.reset;
        this.inUpdateState = true;
    }

    onPaginationNavigation(vehicles, pageNum) {
        if (this.inUpdateState || pageNum !== this.sharedPageNum) {
            this.filteredVehicles = vehicles.items;
            this.sharedPageNum = pageNum;
            this.inUpdateState = false;
        }
    }

    toggleVehicleSelection(vehicle) {
        vehicle.selected = !vehicle.selected;
        this.vehiclesChanged();
        this.updateSelectionSummary();
    }

    formatCellContent(content) {
        return this.filterApplicable ? this.$filter('highlightPhrase')(content || '', this.query, 'bold') : content;
    }

    setModelIndex(option, index) {
        this.selectedModel = option;
        this.selectedModelIndex = index;
    }

    numSelectedVehicles() {
        return this.selectedVehicles && this.selectedVehicles.length ? this.selectedVehicles.length : 0;
    }

    next(nextFn) {
        nextFn(this.claimVm);
    }
}

CAFleetCtrl.$inject = ['$scope', '$filter', '$translate', 'claimViewModel', 'fnol.PolicyService', 'TranslateService', 'LocaleService', 'AddressUtil', 'fleetPageSize'];

export default CAFleetCtrl;
